module.exports = __webpack_public_path__ + "static/media/comment.6dcde126.svg";